export default "__VITE_ASSET__BcwpdoD3__"